"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Globe, Cpu, Activity, Terminal } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  id: 1,
  label: "AVERAGE PAIN REDUCTION",
  value: "90%",
  icon: Activity,
  flicker: false,
  color: "text-primary"
}, {
  id: 2,
  label: "REACTION IMPROVEMENT",
  value: "15ms",
  icon: Cpu,
  flicker: true,
  color: "text-primary"
}, {
  id: 3,
  label: "ATHLETIC RECOVERY RATE",
  value: "45%",
  icon: Globe,
  flicker: false,
  color: "text-primary"
}];
const leaderboardData = [{
  rank: 1,
  alias: "ELITE_SPRINTER_01",
  score: "99.8",
  status: "OPTIMIZED",
  statusColor: "text-primary"
}, {
  rank: 2,
  alias: "PRO_QUARTERBACK_X",
  score: "98.2",
  status: "IN TRAINING",
  statusColor: "text-primary"
}, {
  rank: 3,
  alias: "D1_MIDFIELDER_99",
  score: "97.5",
  status: "RECOVERED",
  statusColor: "text-muted-foreground"
}, {
  rank: 4,
  alias: "IRONMAN_CHAMP_22",
  score: "95.9",
  status: "OPTIMIZED",
  statusColor: "text-primary"
}, {
  rank: 5,
  alias: "CROSSFIT_GAMES_VET",
  score: "94.1",
  status: "OPTIMIZED",
  statusColor: "text-primary"
}];
export default function PerformanceResults() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225270" id="performance-results" className="dark bg-background text-foreground relative overflow-hidden py-24" ref={sectionRef}>
      {}
      <div className="absolute inset-0 z-0 opacity-5 bg-cover bg-center pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/athlete_silhouette_performance.png)"
    }} />
      
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[linear-gradient(to_right,#ffffff12_1px,transparent_1px),linear-gradient(to_bottom,#ffffff12_1px,transparent_1px)] bg-[size:40px_40px]" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 text-primary border border-primary/30 mb-6">
            <Terminal className="w-4 h-4" />
            <span className="text-sm font-default font-bold tracking-widest uppercase">
              NEURAL PRECISION DATA
            </span>
          </div>
          <h2 className="text-4xl md:text-6xl font-default font-black mb-6 tracking-tighter uppercase">
            PERFORMANCE <span className="text-primary italic">RESULTS</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-default uppercase tracking-wide">
            MEASURABLE IMPROVEMENTS IN NEURO-SENSORY FUNCTION AND ATHLETIC OUTPUT THROUGH TARGETED TRAINING.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
          {statsData.map((stat, i) => <div key={stat.id} data-index={i} className={`transition-all duration-700 delay-${i * 200} transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="bg-secondary/50 border-primary/20 rounded-md backdrop-blur-sm relative overflow-hidden group">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <CardContent className="p-8 flex flex-col items-center text-center relative z-10">
                  <stat.icon className={`w-10 h-10 mb-6 ${stat.color} opacity-90`} />
                  <div className={`text-6xl md:text-8xl font-default font-black tracking-tighter mb-4 ${stat.flicker ? "animate-pulse text-primary drop-shadow-[0_0_15px_rgba(0,102,255,0.4)]" : "text-foreground"}`}>
                    {stat.value}
                  </div>
                  <div className="w-16 h-px bg-primary/40 mb-4" />
                  <div className="text-xs font-default font-bold text-muted-foreground uppercase tracking-[0.2em]">
                    {stat.label}
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div className={`max-w-4xl mx-auto transition-all duration-1000 delay-500 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          

          <div className="rounded-md border border-primary/20 bg-secondary/40 backdrop-blur-md overflow-hidden">
            
          </div>
        </div>
      </div>
    </section>;
}